<script lang="ts" setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router/composables'
import { track } from '@/track'

const props = withDefaults(
  defineProps<{
    id?: string
    name: string
    type: 'page' | 'modal' | 'popup' | 'image' | 'button' | 'block' | string
    delay?: number // Simple delay report for some data fetch
    extra?: Record<string, any>
  }>(),
  {
    id: 'elementShow',
    delay: 0,
  },
)

const route = useRoute()
onMounted(() => {
  setTimeout(() => {
    track(props.id, {
      name: props.name,
      element_name: props.name,
      element_type: props.type,
      current_page: route.fullPath,
      current_page_title: route.meta?.title ?? '',
      ...props.extra,
    })
  }, props.delay * 1000)
})
</script>

<template>
  <div>
    <slot />
  </div>
</template>
